import React from 'react';

/**
 * Zeigt nur tatsächlich getroffene Entscheidungen. Jeder Eintrag ist zugleich
 * ein Rücksprungpunkt; die übergeordnete App entfernt danach abhängige Werte.
 */
export default function Breadcrumbs({items, title, onNavigate}) {
  if (!items.length) return null;
  return (
    <nav className="pf-breadcrumbs" aria-label={title}>
      <span>{title}:</span>
      <ol>
        {items.map((item, index) => (
          <li key={item.step}>
            <button type="button" onClick={() => onNavigate(item.step)}>{item.label}</button>
            {index < items.length - 1 && <span aria-hidden="true">›</span>}
          </li>
        ))}
      </ol>
    </nav>
  );
}
